export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Raskh",
  "alternateName": "رسخ",
  "url": "https://raskh.app",
  "description": "AI-powered bilingual learning platform — make what you learn stay learned."
};
